import { useAuthStore } from '@/shared/model';
import { useAssistantStore } from './assistantStore';
import { useGraphStore } from './graphStore';

/**
 * 계정 전환·로그아웃 시 도깨비 persist 스토어 2종을 비운다.
 *
 * Why: `attachAuthCacheReset`(shared/api)은 react-query 캐시만 비우고, 도깨비의
 * zustand persist localStorage(`dokkaebi-unread-state` / `dokkaebi-graph-view`)는
 * 계정 무관이라 그대로 남는다. 그 결과 계정 B 세션이 계정 A의 대화 ID를 참조해
 * (graphStore.activeConversationId / byConversation, assistantStore.unreadConversations·seenAt)
 * 그 대화를 열려다 403/404로 실패한다.
 *
 * 배선은 shared 가 아니라 여기(features/assistant)에 둔다 — shared → features 는 FSD 역방향.
 * app 레이어(main.tsx)가 호출한다.
 *
 * @returns 구독 해제 함수
 */
export function attachAssistantAuthReset(): () => void {
  let prevUserId = useAuthStore.getState().user?.id ?? null;

  return useAuthStore.subscribe((state) => {
    const nextUserId = state.user?.id ?? null;
    if (prevUserId === nextUserId) return;
    // prevUserId === null(신규 로그인)은 비울 이전 계정이 없으므로 건너뛴다.
    // 로그아웃(A → null)은 A 잔존물을 비워야 하므로 포함된다.
    if (prevUserId !== null) {
      useAssistantStore.getState().resetForAccountSwitch();
      useGraphStore.getState().resetForAccountSwitch();
    }
    prevUserId = nextUserId;
  });
}
